"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var WidgetManager_1 = require("../../WidgetManager");
var WidgetAdderMenu_1 = __importDefault(require("./WidgetAdderMenu"));
var WidgetAdderUtils_1 = require("./WidgetAdderUtils");
var EditorTypes_1 = require("../../EditorTypes");
var lodash_1 = require("lodash");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var styles = __importStar(require("./WidgetAdder.css"));
var WidgetAdderButton_1 = require("./WidgetAdderButton");
var paragraphStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/Paragraph.css"));
var WidgetAdder = (function (_super) {
    __extends(WidgetAdder, _super);
    function WidgetAdder() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.widgetAdderPosition = EditorTypes_1.WidgetAdderPosition.AfterLastLine;
        _this.adderElem = null;
        _this.placeholderElem = null;
        _this.getPlaceholder = function () {
            if (_this.widgetAdderPosition !== EditorTypes_1.WidgetAdderPosition.Selection) {
                return;
            }
            var _a = _this.props, editor = _a.editor, widgetAdderStore = _a.widgetAdderStore;
            var widgetAdderText = widgetAdderStore.widgetAdderText, isParagraphCentered = widgetAdderStore.isParagraphCentered;
            var placeholderText = widgetAdderStore.getPlaceholderText(editor);
            if (widgetAdderText === "+" && !isParagraphCentered) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { style: { opacity: 0 } }, "+"),
                    placeholderText));
            }
            else if (widgetAdderText === "") {
                return placeholderText;
            }
        };
        _this.handleCreateButtonClick = function (event) {
            event.preventDefault();
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("widgetAdder", {
                action: "togglePlus",
                location: _this.widgetAdderPosition,
            }));
        };
        _this.setPlaceholderRef = function (ref) {
            _this.placeholderElem = ref;
        };
        _this.setAdderRef = function (ref) {
            _this.adderElem = ref;
        };
        _this.getLeftOffset = function () {
            var _a = _this.props, editor = _a.editor, _b = _a.widgetAdderStore, isParagraphCentered = _b.isParagraphCentered, widgetAdderText = _b.widgetAdderText;
            var customLeftOffset = (0, WidgetAdderUtils_1.getCustomLeftOffset)(editor);
            if (!(0, lodash_1.isNil)(customLeftOffset)) {
                return customLeftOffset;
            }
            if (!isParagraphCentered || widgetAdderText === "+" || !_this.placeholderElem) {
                return 0;
            }
            else {
                return _this.placeholderElem.getBoundingClientRect().width / 2;
            }
        };
        return _this;
    }
    Object.defineProperty(WidgetAdder.prototype, "shouldOpenMenu", {
        get: function () {
            return !this.props.widgetAdderStore.shouldForceCloseMenu && (0, WidgetAdderUtils_1.shouldOpenMenu)(this.props.editor);
        },
        enumerable: false,
        configurable: true
    });
    WidgetAdder.prototype.componentDidMount = function () {
        var _this = this;
        this.maybePositionWidgetAdder();
        this.forceRepositioningReactionDisposer = (0, mobx_1.reaction)(function () {
            return _this.props.widgetAdderStore.forceRepositionObservable;
        }, function () {
            _this.maybePositionWidgetAdder();
        });
        if ("ResizeObserver" in window) {
            (0, lodash_1.defer)(function () {
                var editorElem = (0, EditorTypes_1.isHTMLElement)(_this.props.editorElem) ? _this.props.editorElem : _this.props.editorElem.current;
                if (editorElem) {
                    var editorResizeObserver_1 = new ResizeObserver(function () {
                        _this.maybePositionWidgetAdder();
                    });
                    editorResizeObserver_1.observe(editorElem);
                    _this.editorResizeObserverDisposer = function () { return editorResizeObserver_1.unobserve(editorElem); };
                }
            });
        }
    };
    WidgetAdder.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.editorResizeObserverDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
        return this.forceRepositioningReactionDisposer();
    };
    WidgetAdder.prototype.componentDidUpdate = function () {
        this.maybePositionWidgetAdder();
    };
    WidgetAdder.prototype.maybePositionWidgetAdder = function () {
        if (!this.props.disabled) {
            this.positionWidgetAdder();
        }
    };
    WidgetAdder.prototype.render = function () {
        var _a;
        var _b = this.props, disabled = _b.disabled, widgetManager = _b.widgetManager, editor = _b.editor;
        if (disabled || !widgetManager.canEdit) {
            return react_1.default.createElement("div", { className: "widget-adder", ref: this.setAdderRef });
        }
        var isFocused = this.props.selectionStore.focussed;
        var widgetAdderClassNames = (0, classnames_1.default)("widget-adder", styles.widgetAdder({ position: this.widgetAdderPosition }), { "widget-adder--hidden": !isFocused }, { "widget-adder--display-menu": this.shouldOpenMenu });
        return (react_1.default.createElement("div", { className: widgetAdderClassNames, ref: this.setAdderRef },
            react_1.default.createElement(WidgetAdderButton_1.WidgetAdderButton, { onMouseDown: this.handleCreateButtonClick, className: "widget-adder__create-button" }),
            this.renderMenu(),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("widget-adder__placeholder", (0, WidgetAdderUtils_1.getCustomWidgetAdderClasses)(editor)), ref: this.setPlaceholderRef },
                react_1.default.createElement("p", { style: (0, dynamic_1.assignInlineVars)((_a = {},
                        _a[paragraphStyles.vars.size] = this.props.widgetAdderStore.paragraphFontSize.toString(),
                        _a[paragraphStyles.vars.color] = this.props.widgetAdderStore.paragraphColor.toString(),
                        _a)), className: paragraphStyles.paragraphWidget }, this.getPlaceholder()))));
    };
    WidgetAdder.prototype.positionWidgetAdder = function (shouldRetryOnFailure) {
        var _a, _b;
        var _this = this;
        if (shouldRetryOnFailure === void 0) { shouldRetryOnFailure = true; }
        try {
            var editorElem = (0, EditorTypes_1.isHTMLElement)(this.props.editorElem) ? this.props.editorElem : this.props.editorElem.current;
            if (!editorElem || !this.adderElem) {
                return;
            }
            var _c = (0, WidgetAdderUtils_1.getTopPosition)(this.props.editor, editorElem, this.adderElem, this.getLeftOffset()), top = _c.top, left = _c.left, position = _c.position, text = _c.text, path = _c.path;
            this.widgetAdderPosition = position;
            this.props.widgetAdderStore.currentPath = path !== null && path !== void 0 ? path : null;
            this.props.widgetAdderStore.widgetAdderText = text.toLowerCase();
            if (this.widgetAdderPosition !== EditorTypes_1.WidgetAdderPosition.Selection) {
                this.props.widgetAdderStore.shouldForceCloseMenu = false;
            }
            (0, dynamic_1.setElementVars)(this.adderElem, (_a = {},
                _a[styles.widgetAdderPositionVars.left] = "".concat(left, "px"),
                _a[styles.widgetAdderPositionVars.top] = top,
                _a[styles.widgetAdderPositionVars.visibility] = undefined,
                _a));
        }
        catch (e) {
            if (shouldRetryOnFailure) {
                setTimeout(function () {
                    _this.positionWidgetAdder(false);
                });
            }
            (0, dynamic_1.setElementVars)(this.adderElem, (_b = {},
                _b[styles.widgetAdderPositionVars.left] = undefined,
                _b[styles.widgetAdderPositionVars.top] = undefined,
                _b[styles.widgetAdderPositionVars.visibility] = "hidden",
                _b));
        }
    };
    WidgetAdder.prototype.renderMenu = function () {
        return (react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: this.shouldOpenMenu, classNames: "widget-adder__menu-container", timeout: kaleidoscope_1.AnimationDuration.Short },
            react_1.default.createElement(WidgetAdderMenu_1.default, { widgetManager: this.props.widgetManager, widgetAdderStore: this.props.widgetAdderStore, telemetry: this.props.telemetry, editor: this.props.editor })));
    };
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], WidgetAdder.prototype, "shouldOpenMenu", null);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof EditorTypes_1.WidgetAdderPosition !== "undefined" && EditorTypes_1.WidgetAdderPosition) === "function" ? _a : Object)
    ], WidgetAdder.prototype, "widgetAdderPosition", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], WidgetAdder.prototype, "handleCreateButtonClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], WidgetAdder.prototype, "positionWidgetAdder", null);
    WidgetAdder = __decorate([
        mobx_react_1.observer
    ], WidgetAdder);
    return WidgetAdder;
}(react_1.default.Component));
exports.default = WidgetAdder;
